module.exports = __webpack_public_path__ + "static/media/plan-B1a-mobile-en.451378c3.png";